import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys.js'
import CacheManager from '../../../../cache/CacheManager.js'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import MasterTemplatePageUI from './MasterTemplatePageUI.js'

class MasterTemplatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      template: null,
      //
      generateSubmitted: false,
      downloadMode: false
    }
  }

  render() {
    return (
      <MasterTemplatePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        template={this.state.template}
        onRefreshClick={this.onRefreshClick}
        //
        generateSubmitted={this.state.generateSubmitted}
        onGenerateTemplatesClick={this.onGenerateTemplatesClick}
        //
        downloadMode={this.state.downloadMode}
        onDownloadClick={() => { this.setState({ downloadMode: true }) }}
        onDownloadCancel={() => { this.setState({ downloadMode: false }) }}
        //
        templateCode={this.props.templateCode}
        title={this.props.title}
        activeTab={this.props.activeTab}
        navConfig={this.props.navConfig}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTemplates(context)
  }

  getTemplates(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/master/templates/${this.props.templateCode}`,
      cacheKey: CacheKeys.Templates(this.props.templateCode),
      callback: this.getTemplatesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTemplatesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      template: response.template,
    })
  }

  onGenerateTemplatesClick = () => {
    let generateSubmitted = this.state.generateSubmitted
    if (generateSubmitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      generateSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/master/templates`,
      this.onGenerateTemplatesClickCallback, {}
    )
  }

  onGenerateTemplatesClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      generateSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.onRefreshClick("noBusy")
      }, 10)
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Templates(this.props.templateCode))
    if (noBusy === 'noBusy') {
      this.getTemplates(context)
    }
    else {
      this.setState({
        template: null,
        errorList: null,
      })
      this.getTemplates(context)
    }
  }
}

export default MasterTemplatePageSF
